// extracted by mini-css-extract-plugin
export var printerCard = "_b1-1";
export var printerCardConfigured = "_b1-2";
export var printerCardError = "_b1-3";
export var printerCardsContainer = "_b1-0";
export var printerIcon = "_b1-8";
export var printerIconConfigured = "_b1-5";
export var printerIconContainer = "_b1-4";
export var printerIconError = "_b1-6";
export var printerIconUnconfigured = "_b1-7";
export var workstationsTableCard = "_b1-9";